import {undef} from './';

function allowFieldAutoProgress(form, field) {
    const {
        options: {
            autoProgress: formAutoProgress
        }
    } = form;

    const {
        options: {
            autoProgress: fieldAutoProgress
        }
    } = field;

    return (
        fieldAutoProgress ||
        formAutoProgress && fieldAutoProgress === undef
    );
}

function allowFieldAutoSubmit(form, field) {
    const {
        options: {
            autoSubmit: formAutoSubmit
        }
    } = form;

    const {
        options: {
            autoSubmit: fieldAutoSubmit
        }
    } = field;

    return (
        fieldAutoSubmit ||
        formAutoSubmit && fieldAutoSubmit === undef
    );
}

function allowInputFieldErrorHighlighting(form, field) {
    const {
        options: {
            allowErrorHighlighting: allowFormErrorHighlighting
        }
    } = form;

    const {
        options: {
            allowErrorHighlighting: allowFieldErrorHighlighting
        }
    } = field;

    return (
        allowFieldErrorHighlighting ||
        allowFormErrorHighlighting && allowFieldErrorHighlighting === undef
    );
}

export {
    allowFieldAutoProgress,
    allowFieldAutoSubmit,
    allowInputFieldErrorHighlighting
};
